import FlightIcon from '@mui/icons-material/Flight'
import MonitorIcon from '@mui/icons-material/Monitor'

// Used to get Image for radio buttons depends on key
const OPTIONS = {
    cps: MonitorIcon,
    carrier: FlightIcon
}

// options used for cps issue dropdown in contact-us page before login
const CPS_OPTIONS_PRE_LOGIN = [
    {value: 'General Service Queries', label: 'General Service Queries', groupHead: true},
    {value: 'General Query', label: 'General Query'},
    {value: 'Register New User', label: 'Register New User'},
    {value: 'Forgot Password', label: 'Forgot Password'},
    {value: 'Carrier Information', label: 'Carrier Information'},
    {value: 'Credit Limit Exceeded for Booking', label: 'Credit Limit Exceeded for Booking'},
    {value: 'Print Shipping Label', label: 'Print Shipping Label'},
    {value: 'Message Reference', label: 'Message Reference'},
    {value: 'System Problem', label: 'System Problem'},
    {value: 'Scheduled Maintenance', label: 'Scheduled Maintenance'},
    {value: 'FAQ & Help', label: 'FAQ & Help'}
]

// options used for cps issue dropdown in contact-us page after login
const CPS_OPTIONS_POST_LOGIN = [
    {value: 'General Service Queries', label: 'General Service Queries', groupHead: true},
    {value: 'General Query', label: 'General Query'},
    {value: 'Register New User', label: 'Register New User'},
    {value: 'Forgot Password', label: 'Forgot Password'},
    {value: 'Carrier Information', label: 'Carrier Information'},
    {value: 'Credit Limit Exceeded for Booking', label: 'Credit Limit Exceeded for Booking'},
    {value: 'Print Shipping Label', label: 'Print Shipping Label'},
    {value: 'Message Reference', label: 'Message Reference'},
    {value: 'System Problem', label: 'System Problem'},
    {value: 'Scheduled Maintenance', label: 'Scheduled Maintenance'},
    {value: 'FAQ & Help', label: 'FAQ & Help'},
    {value: 'Booking', label: 'Booking', groupHead: true},
    {value: 'Search Availability', label: 'Search Availability'},
    {value: 'Search Availability and price', label: 'Search Availability and price'},
    {value: 'Create / Modify Booking', label: 'Create / Modify Booking'},
    {value: 'Create Multiple Bookings', label: 'Create Multiple Bookings'},
    {value: 'Create / Modify Booking Templates', label: 'Create / Modify Booking Templates'},
    {value: 'Create Recurring Booking Template', label: 'Create Recurring Booking Template'},
    {value: 'Create Spreadsheet Bookings', label: 'Create Spreadsheet Bookings'},
    {value: 'Create Air Waybill Stock Request', label: 'Create Air Waybill Stock Request'},
    {value: 'Create Allotment Request', label: 'Create Allotment Request'},
    {value: 'View Allotment Status', label: 'View Allotment Status'},
    {value: 'View Rate Estimate', label: 'View Rate Estimate'},
    {value: 'View Carrier Schedules', label: 'View Carrier Schedules'},
    {value: 'e-Freight', label: 'e-Freight', groupHead: true},
    {value: 'Create / Retrieve MAWB', label: 'Create / Retrieve MAWB'},
    {value: 'View Retrieve Cargo Receipt', label: 'View Retrieve Cargo Receipt'},
    {value: 'View e-Message', label: 'View e-Message'},
    {value: 'Create / Modify HAWB', label: 'Create / Modify HAWB'},
    {value: 'Create / Modify HAWB Template', label: 'Create / Modify HAWB Template'},
    {value: 'Create / Modify Piece ID Info', label: 'Create / Modify Piece ID Info'},
    {value: 'View Piece ID History', label: 'View Piece ID History'},
    {value: 'View Piece ID Status', label: 'View Piece ID Status'},
    {value: 'Manage Shipments', label: 'Manage Shipments', groupHead: true},
    {value: 'Track Shipments', label: 'Track Shipments'},
    {value: 'Search Air Waybills', label: 'Search Air Waybills'},
    {value: 'View / Modify Booking', label: 'View / Modify Booking'},
    {value: 'Review Active / Queued Bookings', label: 'Review Active / Queued Bookings'},
    {value: 'Print Barcode Shipping label', label: 'Print Barcode Shipping label'},
    {value: 'Make Online Payments', label: 'Make Online Payments'},
    {value: 'View Air Waybill Stock Status', label: 'View Air Waybill Stock Status'},
    {value: 'View Flight Status', label: 'View Flight Status'},
    {value: 'View Custom Status', label: 'View Custom Status'},
    {value: 'View Archived Air Waybill', label: 'View Archived Air Waybill'},
    {value: 'Shipment Status by Email', label: 'Shipment Status by Email'},
    {value: 'Review Specialized Bookings', label: 'Review Specialized Bookings'},
    {value: 'e-Docs', label: 'e-Docs', groupHead: true},
    {value: 'My Booking Documents', label: 'My Booking Documents'},
    {value: 'Air Waybill Documents', label: 'Air Waybill Documents'},
    {value: 'e-Finances', label: 'e-Finances', groupHead: true},
    {value: 'View Invoices', label: 'View Invoices'},
    {value: 'View Payment Details', label: 'View Payment Details'},
    {value: 'e-Claims', label: 'e-Claims', groupHead: true},
    {value: 'Create / Modify Preliminary Claim', label: 'Create / Modify Preliminary Claim'},
    {value: 'Create / Modify Final Claim', label: 'Create / Modify Final Claim'},
    {value: 'View Claim Status', label: 'View Claim Status'},
    {value: 'Offers', label: 'Offers', groupHead: true},
    {value: 'Request a Spot Rate', label: 'Request a Spot Rate'},
    {value: 'Carrier Spot Rate offers', label: 'Carrier Spot Rate offers'},
    {value: 'Print Functionality', label: 'Print Functionality', groupHead: true},
    {value: 'Print MAWB', label: 'Print MAWB'},
    {value: 'Print Cargo Receipt', label: 'Print Cargo Receipt'},
    {value: 'Print Shipping Label', label: 'Print Shipping Label'},
    {value: 'Print Shipment Declaration', label: 'Print Shipment Declaration'}
]

interface ContactLoaderType {
    initialValues: object
    isAuthenticated: boolean
    issueCPSOptions: object[]
    carrierOptions: object[]
    phoneCode: string
}

export {OPTIONS, CPS_OPTIONS_PRE_LOGIN, CPS_OPTIONS_POST_LOGIN}

export type {ContactLoaderType}
